export function updateSelectedOption() {
    var selectElement = document.querySelector('select[name="spielraeumeFilter"]');
    if(selectElement) {
        var selectedOption = selectElement.querySelector('.is-active').textContent.trim();
        var selectedDiv = document.querySelector('.customSelect__selected');
        selectedDiv.textContent = selectedOption;
    }

}